function formatCoordinate(coord?: number, minDecimals = 6) {
  if (!coord) return '';
  const [integerPart, decimalPart = ''] = coord.toString().split('.');
  if (decimalPart.length < minDecimals) {
    return `${integerPart}.${decimalPart.padEnd(minDecimals, '0')}`;
  }
  return coord.toString();
}

export function formatStartingPoint(startingPoint?: {
  longitude?: number;
  latitude?: number;
}) {
  if (!startingPoint)
    return {
      latitude: '',
      longitude: '',
    };

  return {
    latitude: formatCoordinate(startingPoint.latitude),
    longitude: formatCoordinate(startingPoint.longitude),
  };
}
